import DetailPageV3Connected from './DetailPageV3'

export default DetailPageV3Connected
// eslint-disable-next-line import/export
export * from './DetailPageV3'
